import {GOOGLE_TAG_MANAGER_ID} from '~config/constants';



export const tagManagerArgs = {
    gtmId: GOOGLE_TAG_MANAGER_ID
};
